import React from 'react'
import styled, {css} from 'styled-components'
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import H3 from 'components/Primatives/H3';
import FlexColumn from 'components/Primatives/FlexColumn';

// Constants
import { constants } from 'constants/index';

export const MainIconWrapper = styled(FontAwesomeIcon)`
    color: ${constants.color.primary};
`;
export const LabelWrapper = styled.label`
    margin: 0;
    font: 16px Open Sans, Helvetica, sans-serif;
    /* width: 6vw; */
    color: grey;
    margin-left: 15px;
    flex: 1;
`;
export const FieldWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 25px;
`;

const FormSectionTitle = ({label, subTitle, mainIconType, style, ...styleProps}) => {
    return (
        <FlexColumn>
            <FieldWrapper style={style}>
                <MainIconWrapper
                    icon={mainIconType}
                    size="3x"
                    style={styleProps.mainIcon}
                />
                <LabelWrapper
                    style={styleProps.labelProps}
                >
                    {label}
                </LabelWrapper>
            </FieldWrapper>
            { subTitle && 
                <H3>{subTitle}</H3>
            }
        </FlexColumn>
    )
}

export default FormSectionTitle;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormSectionTitle.js